import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const DeleteRowDialog = ({
  visible,
  row,
  onHide,
  onConfirm,
  loading = false,
}) => {
  const footer = (
    <div>
      <Button label="Отменить" className="p-button-text" onClick={onHide} />
      <Button label="Удалить" className="p-button-danger" loading={loading} onClick={onConfirm} />
    </div>
  );

  return (
    <Dialog header="Удалить строку" visible={visible} style={{ width: "28rem" }} onHide={onHide} footer={footer} modal>
      <p style={{ margin: 0 }}>
        Удалить строку для КАТО {row?.kato || "—"} {row?.locality ? `(${row.locality})` : ""}?
      </p>
    </Dialog>
  );
};

export default DeleteRowDialog;
